import { render, staticRenderFns } from "./NewsHistory.vue?vue&type=template&id=bb1f6816&scoped=true"
import script from "./NewsHistory.vue?vue&type=script&lang=js"
export * from "./NewsHistory.vue?vue&type=script&lang=js"
import style0 from "./NewsHistory.vue?vue&type=style&index=0&id=bb1f6816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1f6816",
  null
  
)

export default component.exports